export const FETCH_REVENUE_BY_NETWORK_INIT = "FETCH_REVENUE_BY_NETWORK_INIT";

export const FETCH_REVENUE_BY_NETWORK_LIST = {
  START: "FETCH_REVENUE_BY_NETWORK_LIST_START",
  SUCCESS: "FETCH_REVENUE_BY_NETWORK_LIST_SUCCESS",
  ERROR: "FETCH_REVENUE_BY_NETWORK_LIST_ERROR",
};

export const EXPORT_REVENUE_BY_NETWORK = {
  START: "EXPORT_REVENUE_BY_NETWORK_START",
  SUCCESS: "EXPORT_REVENUE_BY_NETWORK_SUCCESS",
  ERROR: "EXPORT_REVENUE_BY_NETWORK_ERROR",
};

export const TOAST = {
  RESET: "RESET_TOAST",
};

export const SET_REVENUE_BY_NETWORK_FILTERS = "SET_REVENUE_BY_NETWORK_FILTERS";
export const CLEAR_REVENUE_BY_NETWORK_FILTERS = "CLEAR_REVENUE_BY_NETWORK_FILTERS";
